import { AlertType, AlertFocusIdentity } from '@aloft/toolkit-shared';

import {
  setFocusedAlertType,
  setMobileReferenceMenuOpen,
  setReferenceViewOpen,
  setSelectedDataSheet,
} from '../redux/features/referenceBarUISlice.ts';
import { store } from '../redux/store.ts';

export type FocusedAlert = AlertType | AlertFocusIdentity;

export const openAlerts = (focusedAlert?: FocusedAlert) => {
  store.dispatch(setSelectedDataSheet('craftsman-alerts'));
  store.dispatch(setReferenceViewOpen(true));
  store.dispatch(setMobileReferenceMenuOpen(false));
  store.dispatch(setFocusedAlertType(focusedAlert ?? null));
};
